import { Container } from "@wojo/ui";
import React from "react";
import styles from "./SplitLayout.module.scss";

export const SplitLayout: React.FC<React.PropsWithChildren<{}>> = ({
    children,
}) => {
    return <Container contentsClassName={styles.grid}>{children}</Container>;
};
